import { render, staticRenderFns } from "./ReleaseEdit.vue?vue&type=template&id=4cd86668&scoped=true&"
import script from "./ReleaseEdit.vue?vue&type=script&lang=js&"
export * from "./ReleaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseEdit.vue?vue&type=style&index=0&id=4cd86668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd86668",
  null
  
)

export default component.exports